import { useEffect, useState } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { useReducedMotion } from '../../hooks/useReducedMotion';
import { rafThrottle } from '../../lib/utils/throttle';

/**
 * Fixed scroll progress bar at the top of the page.
 * Shows user's progress through the landing page.
 */
export function ScrollProgressBar() {
    const [progress, setProgress] = useState(0);
    const reducedMotion = useReducedMotion();

    useEffect(() => {
        const updateProgress = rafThrottle(() => {
            const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrolled = window.scrollY / scrollHeight;
            setProgress(Math.min(1, Math.max(0, scrolled)));
        });

        window.addEventListener('scroll', updateProgress, { passive: true });
        return () => window.removeEventListener('scroll', updateProgress);
    }, []);

    return (
        <div
            className="fixed top-0 left-0 right-0 h-1 z-50 bg-charcoal-900/20"
            role="progressbar"
            aria-valuenow={Math.round(progress * 100)}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label="Page scroll progress"
        >
            <div
                className="h-full bg-gradient-to-r from-[var(--fire-red)] via-[var(--fire-orange)] to-[var(--fire-yellow)]"
                style={{
                    transform: `scaleX(${progress})`,
                    transformOrigin: 'left',
                    transition: reducedMotion ? 'none' : 'transform 0.1s linear'
                }}
            />
        </div>
    );
}

export default ScrollProgressBar;
